"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataPresenterTable = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.DataPresenterTable = styled_components_1.default.table `
  border: 1px solid black;

  thead {
    th {
      font-weight: bold;
      background-color: #ccc;
      border: 1px solid black;
      padding: 5px;
    }
  }

  tbody {
    overflow-y: auto;
    border: 1px solid black;
  }

  tr {
    background-color: #eee;
    td {
      border: 1px solid black;
      padding: 5px;
    }
  }

  tr:nth-child(even) {
    background-color: #fcfcfc;
  }
`;
//# sourceMappingURL=data-presenter-table.js.map